import type { FormikProps } from 'formik'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

export interface NewTrainingsSessionFormValues {
  name: string
  startsAt: string
  startsAtHour: string
  endsAt: string
  endsAtHour: string
  dueDate: string
  duration?: number
  hours?: string
  minutes?: string
  modality?: string
  link?: string
  location?: string
  caducity: boolean
  subsidized: boolean
}

export interface NewSessionRUFormValues {
  trainingSchedule: string
}

export interface SessionForm {
  session: NewTrainingsSessionFormValues
  relatorioUnico: NewSessionRUFormValues
}

export const useSessionsForm = () => {
  const modalityOptions = [
    {
      label: i18n.t('trainings.sessions_table.online'),
      value: 'online',
    },
    {
      label: i18n.t('trainings.sessions_table.inperson'),
      value: 'inperson',
    },
    {
      label: i18n.t('trainings.sessions_table.mixed'),
      value: 'mixed',
    },
  ]

  const setDefaultTime = () => {
    const ROUND_TIME = 1000 * 60 * 30
    const date = new Date()
    const roundDateAndTime = new Date(Math.round(date.getTime() / ROUND_TIME) * ROUND_TIME)
    const dateISO = roundDateAndTime.toISOString()

    return dateISO
  }

  const localeData = moment.localeData()
  const format = localeData.longDateFormat('L')

  const getDay = (date: string, currentDate: string) => {
    const newDate = moment(date, format)
    const existingDate = moment(currentDate, format)
    existingDate
      .set('date', newDate.date())
      .set('month', newDate.month())
      .set('year', newDate.year())
    return existingDate.format('L')
  }

  const setHourFromBackend = (time: string) => {
    const existingTime = moment(time)
    return existingTime.format('HH:mm')
  }

  const buildTime = (day: string, hour: string) => {
    const time = moment(day, format)
    const existingHours = moment(hour, 'HH:mm')

    const formattedTime = time
      .set('hour', existingHours.hour())
      .set('minutes', existingHours.minutes())
    return formattedTime.toISOString()
  }

  const onChangeStartDay = (date: string, form: FormikProps<SessionForm>) => {
    form.setValues({
      ...form.values,
      session: { ...form.values.session, startsAt: getDay(date, form.values.session.startsAt) },
    })
  }

  const onChangeEndDay = (date: string, form: FormikProps<SessionForm>) => {
    form.setValues({
      ...form.values,
      session: { ...form.values.session, endsAt: getDay(date, form.values.session.endsAt) },
    })
  }

  const onChangeDueDate = (date: string, form: FormikProps<SessionForm>) => {
    form.setValues({
      ...form.values,
      session: { ...form.values.session, dueDate: getDay(date, form.values.session.dueDate) },
    })
  }

  const handleHoursChange = (value: string, form: FormikProps<SessionForm>) => {
    const numberValue = Number(value)
    if (isNaN(numberValue) || numberValue < 0) return

    form.setValues({ ...form.values, session: { ...form.values.session, hours: value } })
  }

  const handleMinutesChange = (value: string, form: FormikProps<SessionForm>) => {
    const numberValue = Number(value)
    if (isNaN(numberValue) || numberValue < 0 || numberValue > 59) return

    form.setValues({ ...form.values, session: { ...form.values.session, minutes: value } })
  }

  return {
    setDefaultTime,
    getDay,
    onChangeStartDay,
    onChangeEndDay,
    onChangeDueDate,
    setHourFromBackend,
    buildTime,
    modalityOptions,
    handleHoursChange,
    handleMinutesChange,
  }
}
